module.exports = __webpack_public_path__ + "img/fig9.9.f72046be.png";